import PropTypes from 'prop-types';
import TabNavigation from '../TabNavigation/TabNavigation';
import './PageLayout.css';

const PageLayout = ({
  title,
  children,
  showTabs = false,
  tabs = [],
  className = '',
}) => {
  return (
    <main className={`page-layout container ${className}`}>
      {showTabs && <TabNavigation tabs={tabs} />}
      
      {title !== null && title && (
        <header className="page-header">
          <h1 className="page-header__title">{title}</h1>
        </header>
      )}
      
      <div className="page-content">
        {children}
      </div>
    </main>
  );
};

PageLayout.propTypes = { // proptypes function is used for type checking of props
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  showTabs: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
  className: PropTypes.string,
};

export default PageLayout;

